import { http } from '@/api/http'
import type {
  AddressPayload,
  ApiCustomerAddress,
  UpdateAddressPayload,
} from '@/api/types/address'
import type {
  CreateCustomerResponse,
  Customer,
  CustomerPayload,
  CustomerTransactionsResponse,
  UpdateResponse,
} from '@/api/types'
import { LANGUAGE_CODE } from '@/config/lang'
import { getLanguage } from '@/utils/language'

/**
 * Язык у адресов идёт сегментом маршрута, а не параметром `Language`,
 * который подставляет прокси: на нём бэкенд возвращает название региона.
 */
const languageCode = (): number => LANGUAGE_CODE[getLanguage()]

/** Профиль клиента. Один и тот же payload уходит и на создание, и на обновление. */
export const customersService = {
  getById: (id: string) => http.get<Customer>('/customers/Get/', { Id: id }),
  create: (payload: CustomerPayload) =>
    http.post<CreateCustomerResponse>('/customers/Create', payload),
  update: (payload: CustomerPayload) => http.post<UpdateResponse>('/customers/Update', payload),
  /**
   * История баллов. Даты обязательны: без них бэкенд падает с 500
   * («Nullable object must have a value»). Клиенту без бонусной карты
   * отвечает ошибкой «karta mavjud emas» — истории у него просто нет.
   */
  transactions: (id: string, dateFrom: string, dateTo: string) =>
    http.get<CustomerTransactionsResponse>('/customers/GetTransactions', {
      Id: id,
      DateFrom: dateFrom,
      DateTo: dateTo,
    }),

  /** Создание возвращает весь справочник адресов клиента, а не одну запись. */
  createAddress: (customerId: string, payload: AddressPayload) =>
    http.post<ApiCustomerAddress[]>(
      `/customers/CreateAddress/${customerId}/${languageCode()}`,
      payload,
    ),
  /** Правка отвечает пустым телом — список после неё перечитываем. */
  updateAddress: (payload: UpdateAddressPayload) =>
    http.post<unknown>(`/customers/UpdateAddress/${languageCode()}`, payload),
  deleteAddress: (addressId: number) =>
    http.delete<unknown>(`/customers/DeleteAddress/${addressId}/${languageCode()}`),
}
